export default __webpack_public_path__ + "static/media/activePinkMarker.c747b532.svg";